import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14ba4486"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-top"
};
const _hoisted_2 = {
  class: "pwdSet"
};
const _hoisted_3 = {
  key: 3,
  class: "wordText"
};
const _hoisted_4 = {
  key: 5,
  class: "textArray"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1));
const _hoisted_6 = {
  key: 0,
  class: "el-upload__text"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "click to upload", -1));
const _hoisted_8 = {
  class: "el-upload__tip"
};
const _hoisted_9 = {
  key: 1,
  class: "searchItem search_toggle",
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "margin-right": "15px"
  }
};
const _hoisted_10 = {
  class: "pwdSet"
};
const _hoisted_11 = {
  key: 3,
  class: "wordText"
};
const _hoisted_12 = {
  key: 5,
  class: "textArray"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1));
const _hoisted_14 = {
  key: 0,
  class: "el-upload__text"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "click to upload", -1));
const _hoisted_16 = {
  class: "el-upload__tip"
};
const _hoisted_17 = {
  key: 2,
  class: "cooperation"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EIUploadOnePic = _resolveComponent("EIUploadOnePic");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_tree_select = _resolveComponent("el-tree-select");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_IconSelect = _resolveComponent("IconSelect");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_select_v2 = _resolveComponent("el-select-v2");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_time_select = _resolveComponent("el-time-select");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_dialog_select = _resolveComponent("dialog-select");
  const _component_dialog_tab_select = _resolveComponent("dialog-tab-select");
  const _component_Upload = _resolveComponent("Upload");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_ArrowDown = _resolveComponent("ArrowDown");
  const _component_ArrowUp = _resolveComponent("ArrowUp");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createBlock(_component_el_form, {
    size: $setup.size,
    "label-width": $setup.labelWidth ? $setup.labelWidth : null,
    ref: "commonForm",
    model: $setup.form,
    rules: $setup.formRules,
    disabled: $props.isDetail,
    "label-position": $setup.labelPosition,
    class: _normalizeClass(["commonForm", $props.isDetail ? 'disabledForm' : '']),
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onKeyup: _cache[4] || (_cache[4] = _withKeys($event => $setup.formHandle[0] ? $setup.formHandle[0].handle() : [], ["enter"]))
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [!($props.hasSearchToggle && $setup.toggle) ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(item?.span ? item?.minWidth ? 'search_item_' + item?.span + ' ' + 'search_item_min_' + item?.minWidth : 'search_item_' + item?.span : item?.minWidth ? 'search_item_12 ' + 'search_item_min_' + item?.minWidth : 'search_item_12'),
        key: item?.prop
      }, [!item?.hideHandle?.(item?.prop, $setup.form) && item?.type != 'textarea' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: $setup.showLabel ? item?.label : '',
        prop: item?.prop
      }, {
        default: _withCtx(() => [item?.type === 'upload' ? (_openBlock(), _createBlock(_component_EIUploadOnePic, {
          key: 0,
          type: item?.uploadType,
          "file-list": $setup.form[item?.prop],
          "onUpdate:fileList": $event => $setup.form[item?.prop] = $event,
          onClearValidate: $event => $setup.clearValidate(item?.prop),
          fileType: item?.fileType,
          uploadTip: item?.uploadTip
        }, null, 8, ["type", "file-list", "onUpdate:fileList", "onClearValidate", "fileType", "uploadTip"])) : _createCommentVNode("", true), item?.type === 'text' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          formatter: value => `${value}`.replace(/(^\s*)|(\s*$)/g, ''),
          "show-password": item?.isPassworld,
          disabled: item?.disabledHandle?.(item?.prop, $setup.form),
          size: $setup.size,
          placeholder: item?.placeholder,
          style: _normalizeStyle({
            width: item?.width
          })
        }, _createSlots({
          _: 2
        }, [item?.append ? {
          name: "append",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(item?.append), 1)]),
          key: "0"
        } : undefined]), 1032, ["modelValue", "onUpdate:modelValue", "formatter", "show-password", "disabled", "size", "placeholder", "style"])) : _createCommentVNode("", true), item.type === 'passwordStrengthCheck' ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({
            width: item.width
          })
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level0: $setup.psdStrongLevel === 0
          }])
        }, " 弱 ", 2), _createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level1: $setup.psdStrongLevel === 1
          }])
        }, " 中 ", 2), _createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level2: $setup.psdStrongLevel === 2
          }])
        }, " 安全 ", 2)]), _createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item.prop],
          "onUpdate:modelValue": $event => $setup.form[item.prop] = $event,
          formatter: value => `${value}`.replace(/(^\s*)|(\s*$)/g, ''),
          "show-password": item.isPassworld,
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          size: $setup.size,
          placeholder: item.placeholder,
          onInput: _ctx.changePsdStrong
        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "show-password", "disabled", "size", "placeholder", "onInput"])], 4)) : _createCommentVNode("", true), item?.type === 'wordText' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.form[item?.prop]), 1)) : _createCommentVNode("", true), item?.type === 'textareaNotRemark' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 4,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          type: "textarea",
          formatter: value => `${value}`.replace(/(^\s*)|(\s*$)/g, ''),
          disabled: item?.disabled,
          placeholder: item?.placeholder,
          maxlength: "200",
          "show-word-limit": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "disabled", "placeholder"])) : _createCommentVNode("", true), item?.type === 'textArray' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item?.propStart],
          "onUpdate:modelValue": $event => $setup.form[item?.propStart] = $event,
          modelModifiers: {
            trim: true
          },
          disabled: item?.disabledHandle?.(item?.propStart, $setup.form),
          size: $setup.size,
          style: _normalizeStyle({
            width: item?.width
          })
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "size", "style"]), _hoisted_5, _createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item?.propEnd],
          "onUpdate:modelValue": $event => $setup.form[item?.propEnd] = $event,
          modelModifiers: {
            trim: true
          },
          disabled: item?.disabledHandle?.(item?.propEnd, $setup.form),
          size: $setup.size,
          placeholder: item?.placeholder,
          style: _normalizeStyle({
            width: item?.width
          })
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "size", "placeholder", "style"])])) : _createCommentVNode("", true), item?.type === 'textNum' ? (_openBlock(), _createBlock(_component_el_input_number, {
          key: 6,
          style: {
            "width": "100%"
          },
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          "controls-position": "right",
          disabled: item?.disabledHandle?.(item?.propEnd, $setup.form),
          min: item?.min,
          max: item?.max,
          precision: item?.precision,
          step: item?.step || 1,
          onInput: $setup.inputLimit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "min", "max", "precision", "step", "onInput"])) : _createCommentVNode("", true), item?.type === 'tree' ? (_openBlock(), _createBlock(_component_el_tree_select, {
          key: 7,
          "check-strictly": true,
          placeholder: item?.placeholder,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled,
          data: item?.options,
          "render-after-expand": false,
          props: item.props ? item.props : {
            label: 'label',
            value: 'id',
            children: 'children'
          }
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "data", "props"])) : _createCommentVNode("", true), item.type === 'elTree' ? (_openBlock(), _createBlock(_component_el_tree, {
          key: 8,
          style: {
            "width": "100%"
          },
          "check-strictly": item.strictly ? item.strictly : false,
          data: item.options || [],
          "show-checkbox": "",
          ref_for: true,
          ref: "menu",
          "node-key": item.nodeKey ? item.nodeKey : 'id',
          "empty-text": "加载中，请稍后",
          props: item.props
        }, null, 8, ["check-strictly", "data", "node-key", "props"])) : _createCommentVNode("", true), item.type === 'iconSelect' ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 9,
          "popper-class": "iconSelectPopover",
          placement: "bottom-start",
          width: item.width,
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_input, {
            class: "iconSelectInput",
            modelValue: $setup.form[item.prop],
            "onUpdate:modelValue": $event => $setup.form[item.prop] = $event,
            modelModifiers: {
              trim: true
            },
            placeholder: "点击选择图标",
            readonly: ""
          }, {
            prefix: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass($setup.form.icon ? $setup.form.icon : 'el-icon-search')
            }, null, 2)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]),
          default: _withCtx(() => [_createVNode(_component_IconSelect, {
            ref_for: true,
            ref: "iconSelectVlue",
            onSelected: item.selected
          }, null, 8, ["onSelected"])]),
          _: 2
        }, 1032, ["width"])) : _createCommentVNode("", true), item?.type === 'list' || item?.type === 'list_multi' ? (_openBlock(), _createBlock(_component_el_select, {
          key: 10,
          clearable: item.clearable === false ? false : true,
          "collapse-tags": "",
          filterable: item?.filterable ? item?.filterable : false,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          multiple: item?.type === 'list_multi' || item?.multiple,
          disabled: item?.disabled || item?.disabledHandle?.(item?.prop, $setup.form),
          style: _normalizeStyle({
            width: item?.width
          }),
          size: $setup.size,
          onChange: $event => item?.change && item.change($setup.form[item?.prop], $setup.getOptions(item, index), item)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getOptions(item, index), op => {
            return _openBlock(), _createBlock(_component_el_option, {
              label: item?.props ? op[item?.props?.label] : op?.dictLabel,
              value: item?.props ? op[item?.props?.value] : op?.dictValue,
              key: item.props ? op[item?.props?.value] : op?.dictValue,
              disabled: op?.disabled
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 2
        }, 1032, ["clearable", "filterable", "placeholder", "modelValue", "onUpdate:modelValue", "multiple", "disabled", "style", "size", "onChange"])) : _createCommentVNode("", true), item?.type === 'bigData_list_multi' ? (_openBlock(), _createBlock(_component_el_select_v2, {
          key: 11,
          clearable: "",
          "collapse-tags": "",
          filterable: item?.filterable ? item?.filterable : true,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          multiple: item?.multiple,
          options: $setup.getOptions(item, index),
          props: item?.props ? item.props : {
            label: 'label',
            value: 'value'
          },
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          style: _normalizeStyle({
            width: item?.width
          }),
          size: $setup.size,
          onChange: $event => item?.change && item.change($setup.form[item?.prop], $setup.getOptions(item, index))
        }, null, 8, ["filterable", "placeholder", "modelValue", "onUpdate:modelValue", "multiple", "options", "props", "disabled", "style", "size", "onChange"])) : _createCommentVNode("", true), item?.type === 'radio' ? (_openBlock(), _createBlock(_component_el_radio_group, {
          key: 12,
          disabled: item?.disabled,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          onChange: $event => item?.change($setup.form[item?.prop], item?.options)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.options, ra => {
            return _openBlock(), _createBlock(_component_el_radio, {
              label: ra.label === false ? false : ra.value || ra[item.props.value],
              key: ra[item?.props?.value] || ra?.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(ra[item?.props?.label || ra?.label]), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 2
        }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'checkbox' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
          key: 13,
          onChange: $event => item?.change($setup.form[item?.prop], item?.options),
          disabled: item?.disabled,
          style: _normalizeStyle({
            width: item?.width
          }),
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.options, ch => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              label: ch?.value,
              key: ch?.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(ch?.label), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 2
        }, 1032, ["onChange", "disabled", "style", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item?.type === 'month' || item?.type === 'monthrange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 14,
          disabled: item?.disabled,
          type: item?.type,
          placeholder: '请选择' + item?.label,
          "value-format": item?.valueFormat || 'YYYY-MM',
          format: "YYYY-MM",
          style: {
            "width": "100%"
          },
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : $setup.dateClearHandle($setup.form[item?.prop], $setup.form)
        }, null, 8, ["disabled", "type", "placeholder", "value-format", "shortcuts", "disabled-date", "picker-options", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'date' || item?.type === 'daterange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 15,
          disabled: item?.disabled,
          type: item?.type,
          placeholder: '请选择' + item?.label,
          "value-format": item?.valueFormat || 'YYYY-MM-DD',
          format: "YYYY-MM-DD",
          style: {
            "width": "100%"
          },
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : $setup.dateClearHandle($setup.form[item?.prop], $setup.form)
        }, null, 8, ["disabled", "type", "placeholder", "value-format", "shortcuts", "disabled-date", "picker-options", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'time' ? (_openBlock(), _createBlock(_component_el_time_select, {
          key: 16,
          style: {
            "width": "100%"
          },
          format: item?.format || 'HH:mm:ss',
          "value-format": item?.valueFormat || 'HH:mm:ss',
          "picker-options": item?.pickerOptions,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null
        }, null, 8, ["format", "value-format", "picker-options", "disabled", "placeholder", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'datetime' || item?.type === 'datetimerange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 17,
          style: {
            "width": "100%"
          },
          type: item?.type,
          format: item?.format || 'YYYY-MM-DD HH:mm:ss',
          "value-format": item?.valueFormat || 'YYYY-MM-DD HH:mm:ss',
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          placeholder: '请选择' + item?.label,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          class: _normalizeClass(item?.className ? item.className : ''),
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null
        }, null, 8, ["type", "format", "value-format", "shortcuts", "disabled-date", "picker-options", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "class", "onChange"])) : _createCommentVNode("", true), item?.type === 'switch' ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 18,
          disabled: item?.disabled,
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null,
          "active-value": item?.switch?.active || item?.switch?.active === 0 ? item?.switch?.active : '0',
          "inactive-value": item?.switch?.inActive || item?.switch?.inActive === 0 ? item?.switch?.inActive : '1',
          "active-text": item?.switch?.activeText || '',
          "inactive-text": item?.switch?.inActiveText || '',
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event
        }, null, 8, ["disabled", "onChange", "active-value", "inactive-value", "active-text", "inactive-text", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item?.type === 'cascader' ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 19,
          ref_for: true,
          ref: "cascader",
          style: _normalizeStyle({
            width: item.width
          }),
          onChange: $event => item?.change($setup.form[item?.prop], item?.options, $setup.cascader),
          props: item?.treeProps,
          "show-all-levels": item?.textLevel,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          options: item?.options,
          size: item?.size || $setup.size,
          clearable: ""
        }, null, 8, ["style", "onChange", "props", "show-all-levels", "disabled", "placeholder", "modelValue", "onUpdate:modelValue", "options", "size"])) : _createCommentVNode("", true), item?.type === 'cascaderCheck' ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 20,
          ref_for: true,
          ref: "cascaderCheck",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          style: _normalizeStyle({
            width: item.width
          }),
          placeholder: '请选择' + item?.label,
          options: item?.options,
          props: item?.props,
          filterable: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          clearable: "",
          onChange: $event => item?.change($setup.form[item?.prop], item?.options, $setup.cascader)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "style", "placeholder", "options", "props", "onChange"])) : _createCommentVNode("", true), item?.type === 'dialog-select' ? (_openBlock(), _createBlock(_component_dialog_select, {
          key: 21,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          options: item?.options || {
            localConfig: false
          },
          placeholder: '请选择' + item?.label,
          multiple: item?.multiple || false,
          url: item?.optionsUrl,
          extraParams: item?.extraParams || $setup.form,
          extraParamsProps: item?.extraParamsProps,
          needExtraParams: item?.needExtraParams || false,
          showLabel: item?.showLabel ? item.showLabel : false,
          dialogWidth: item?.dialogWidth ? item.dialogWidth : '960px',
          labelStr: $setup.form[item?.labelStr],
          labelStr2: $setup.form[item?.labelStr2],
          labelStr3: $setup.form[item?.labelStr3],
          style: _normalizeStyle({
            width: item?.width
          }),
          onSelectLabel: (val, val2, val3) => {
            item?.selectLabel ? item.selectLabel(val, val2, val3) : null;
          },
          method: item?.method,
          showSelectInfo: item?.showSelectInfo,
          showSelectInfoTip: item?.showSelectInfoTip
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options", "placeholder", "multiple", "url", "extraParams", "extraParamsProps", "needExtraParams", "showLabel", "dialogWidth", "labelStr", "labelStr2", "labelStr3", "style", "onSelectLabel", "method", "showSelectInfo", "showSelectInfoTip"])) : _createCommentVNode("", true), item?.type === 'dialog-tab-select' ? (_openBlock(), _createBlock(_component_dialog_tab_select, {
          key: 22,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          multiple: item?.multiple || false,
          tabsList: item?.tabsList,
          tableHeader: item?.tableHeader,
          noTabsListTip: item?.noTabsListTip,
          labelStr: $setup.form[item?.labelStr],
          style: _normalizeStyle({
            width: item?.width
          }),
          method: item?.method
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder", "multiple", "tabsList", "tableHeader", "noTabsListTip", "labelStr", "style", "method"])) : _createCommentVNode("", true), item?.type === 'basic-upload' ? (_openBlock(), _createBlock(_component_el_upload, {
          key: 23,
          class: "upload-demo",
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          action: item?.action,
          "auto-upload": item?.autoUpload,
          onChange: item?.onChange,
          "on-preview": item?.handlePreview,
          "on-remove": item?.handleRemove,
          "before-upload": item?.beforeUpload,
          "before-remove": item?.beforeRemove,
          multiple: item?.multiple,
          limit: item?.limit || 1,
          "on-exceed": item?.handleExceed,
          "file-list": item?.fileList,
          drag: item?.drag,
          "on-success": item?.onSuccess
        }, {
          tip: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(item?.tip), 1)]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_Upload)]),
            _: 1
          }), item?.drag ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(" Drop file here or "), _hoisted_7])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.upLoadText || "上传"), 1)]),
            _: 2
          }, 1024))]),
          _: 2
        }, 1032, ["disabled", "action", "auto-upload", "onChange", "on-preview", "on-remove", "before-upload", "before-remove", "multiple", "limit", "on-exceed", "file-list", "drag", "on-success"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "prop"])) : _createCommentVNode("", true)], 2);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remark, item => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(item?.span ? item?.minWidth ? 'search_item_' + item?.span + ' ' + 'search_item_min_' + item?.minWidth : 'search_item_' + item?.span : item?.minWidth ? 'search_item_12 ' + 'search_item_min_' + item?.minWidth : 'search_item_12'),
        key: item?.prop
      }, [_createVNode(_component_el_form_item, {
        label: $setup.showLabel ? item?.label : '',
        prop: item?.prop
      }, {
        default: _withCtx(() => [item?.type === 'textarea' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          modelModifiers: {
            trim: true
          },
          type: "textarea",
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          placeholder: item?.placeholder,
          rows: item?.rows || 2,
          maxlength: item?.maxlength || 200,
          "show-word-limit": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder", "rows", "maxlength"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "prop"])], 2)), [[_vShow, !item?.hideHandle?.(item?.prop, $setup.form)]]);
    }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(item?.span ? item?.minWidth ? 'search_item_' + item?.span + ' ' + 'search_item_min_' + item?.minWidth : 'search_item_' + item?.span : item?.minWidth ? 'search_item_12 ' + 'search_item_min_' + item?.minWidth : 'search_item_12'),
        key: item?.prop
      }, [_createVNode(_component_el_form_item, {
        label: $setup.showLabel ? item?.label : '',
        prop: item?.prop
      }, {
        default: _withCtx(() => [item?.type === 'upload' ? (_openBlock(), _createBlock(_component_EIUploadOnePic, {
          key: 0,
          type: item?.uploadType,
          "file-list": $setup.form[item?.prop],
          "onUpdate:fileList": $event => $setup.form[item?.prop] = $event,
          onClearValidate: $event => $setup.clearValidate(item?.prop),
          fileType: item?.fileType,
          uploadTip: item?.uploadTip
        }, null, 8, ["type", "file-list", "onUpdate:fileList", "onClearValidate", "fileType", "uploadTip"])) : _createCommentVNode("", true), item?.type === 'text' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          modelModifiers: {
            trim: true
          },
          "show-password": item?.isPassworld,
          disabled: item?.disabledHandle?.(item?.prop, $setup.form),
          size: $setup.size,
          placeholder: item?.placeholder,
          style: _normalizeStyle({
            width: item?.width
          })
        }, _createSlots({
          _: 2
        }, [item?.append ? {
          name: "append",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(item?.append), 1)]),
          key: "0"
        } : undefined]), 1032, ["modelValue", "onUpdate:modelValue", "show-password", "disabled", "size", "placeholder", "style"])) : _createCommentVNode("", true), item.type === 'passwordStrengthCheck' ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({
            width: item.width
          })
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level0: $setup.psdStrongLevel === 0
          }])
        }, " 弱 ", 2), _createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level1: $setup.psdStrongLevel === 1
          }])
        }, " 中 ", 2), _createElementVNode("div", {
          class: _normalizeClass(["psdShow", {
            level2: $setup.psdStrongLevel === 2
          }])
        }, " 安全 ", 2)]), _createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item.prop],
          "onUpdate:modelValue": $event => $setup.form[item.prop] = $event,
          modelModifiers: {
            trim: true
          },
          "show-password": item.isPassworld,
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          size: $setup.size,
          placeholder: item.placeholder,
          onInput: _ctx.changePsdStrong
        }, null, 8, ["modelValue", "onUpdate:modelValue", "show-password", "disabled", "size", "placeholder", "onInput"])], 4)) : _createCommentVNode("", true), item?.type === 'wordText' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.form[item?.prop]), 1)) : _createCommentVNode("", true), item?.type === 'textareaNotRemark' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 4,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          modelModifiers: {
            trim: true
          },
          type: "textarea",
          disabled: item?.disabled,
          placeholder: item?.placeholder,
          maxlength: "200",
          "show-word-limit": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])) : _createCommentVNode("", true), item?.type === 'textArray' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item?.propStart],
          "onUpdate:modelValue": $event => $setup.form[item?.propStart] = $event,
          modelModifiers: {
            trim: true
          },
          disabled: item?.disabledHandle?.(item?.propStart, $setup.form),
          size: $setup.size,
          style: _normalizeStyle({
            width: item?.width
          })
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "size", "style"]), _hoisted_13, _createVNode(_component_el_input, {
          clearable: "",
          modelValue: $setup.form[item?.propEnd],
          "onUpdate:modelValue": $event => $setup.form[item?.propEnd] = $event,
          modelModifiers: {
            trim: true
          },
          disabled: item?.disabledHandle?.(item?.propEnd, $setup.form),
          size: $setup.size,
          placeholder: item?.placeholder,
          style: _normalizeStyle({
            width: item?.width
          })
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "size", "placeholder", "style"])])) : _createCommentVNode("", true), item?.type === 'textNum' ? (_openBlock(), _createBlock(_component_el_input_number, {
          key: 6,
          style: {
            "width": "100%"
          },
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          modelModifiers: {
            trim: true
          },
          "controls-position": "right",
          disabled: item?.disabledHandle?.(item?.propEnd, $setup.form),
          min: item?.min,
          max: item?.max,
          precision: item?.precision,
          step: item?.step || 1,
          onInput: $setup.inputLimit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "min", "max", "precision", "step", "onInput"])) : _createCommentVNode("", true), item?.type === 'tree' ? (_openBlock(), _createBlock(_component_el_tree_select, {
          key: 7,
          "check-strictly": true,
          placeholder: item?.placeholder,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled,
          data: item?.options,
          "render-after-expand": false,
          props: item.props ? item.props : {
            label: 'label',
            value: 'id',
            children: 'children'
          }
        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "data", "props"])) : _createCommentVNode("", true), item.type === 'elTree' ? (_openBlock(), _createBlock(_component_el_tree, {
          key: 8,
          style: {
            "width": "100%"
          },
          "check-strictly": item.strictly ? item.strictly : false,
          data: item.options || [],
          "show-checkbox": "",
          ref_for: true,
          ref: "menu",
          "node-key": item.nodeKey ? item.nodeKey : 'id',
          "empty-text": "加载中，请稍后",
          props: item.props
        }, null, 8, ["check-strictly", "data", "node-key", "props"])) : _createCommentVNode("", true), item.type === 'iconSelect' ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 9,
          "popper-class": "iconSelectPopover",
          placement: "bottom-start",
          width: item.width,
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_input, {
            class: "iconSelectInput",
            modelValue: $setup.form[item.prop],
            "onUpdate:modelValue": $event => $setup.form[item.prop] = $event,
            modelModifiers: {
              trim: true
            },
            placeholder: "点击选择图标",
            readonly: ""
          }, {
            prefix: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass($setup.form.icon ? $setup.form.icon : 'el-icon-search')
            }, null, 2)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]),
          default: _withCtx(() => [_createVNode(_component_IconSelect, {
            ref_for: true,
            ref: "iconSelectVlue",
            onSelected: item.selected
          }, null, 8, ["onSelected"])]),
          _: 2
        }, 1032, ["width"])) : _createCommentVNode("", true), item?.type === 'list' || item?.type === 'list_multi' ? (_openBlock(), _createBlock(_component_el_select, {
          key: 10,
          clearable: item.clearable === false ? false : true,
          "collapse-tags": "",
          filterable: item?.filterable ? item?.filterable : false,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          multiple: item?.type === 'list_multi' || item?.multiple,
          disabled: item?.disabled || item?.disabledHandle?.(item?.prop, $setup.form),
          style: _normalizeStyle({
            width: item?.width
          }),
          size: $setup.size,
          onChange: $event => item?.change && item.change($setup.form[item?.prop], $setup.getOptions(item, index), item)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getOptions(item, index), op => {
            return _openBlock(), _createBlock(_component_el_option, {
              label: item?.props ? op[item?.props?.label] : op?.dictLabel,
              value: item?.props ? op[item?.props?.value] : op?.dictValue,
              key: item.props ? op[item?.props?.value] : op?.dictValue,
              disabled: op?.disabled
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 2
        }, 1032, ["clearable", "filterable", "placeholder", "modelValue", "onUpdate:modelValue", "multiple", "disabled", "style", "size", "onChange"])) : _createCommentVNode("", true), item?.type === 'bigData_list_multi' ? (_openBlock(), _createBlock(_component_el_select_v2, {
          key: 11,
          clearable: "",
          "collapse-tags": "",
          filterable: item?.filterable ? item?.filterable : true,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          multiple: item?.multiple,
          options: $setup.getOptions(item, index),
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          style: _normalizeStyle({
            width: item?.width
          }),
          size: $setup.size,
          onChange: $event => item?.change && item.change($setup.form[item?.prop], $setup.getOptions(item, index))
        }, null, 8, ["filterable", "placeholder", "modelValue", "onUpdate:modelValue", "multiple", "options", "disabled", "style", "size", "onChange"])) : _createCommentVNode("", true), item?.type === 'radio' ? (_openBlock(), _createBlock(_component_el_radio_group, {
          key: 12,
          disabled: item?.disabled,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          onChange: $event => item?.change($setup.form[item?.prop], item?.options)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.options, ra => {
            return _openBlock(), _createBlock(_component_el_radio, {
              label: ra.label === false ? false : ra.value || ra[item.props.value],
              key: ra[item?.props?.value] || ra?.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(ra[item?.props?.label || ra?.label]), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 2
        }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'checkbox' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
          key: 13,
          onChange: $event => item?.change($setup.form[item?.prop], item?.options),
          disabled: item?.disabled,
          style: _normalizeStyle({
            width: item?.width
          }),
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.options, ch => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              label: ch?.value,
              key: ch?.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(ch?.label), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 2
        }, 1032, ["onChange", "disabled", "style", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item?.type === 'month' || item?.type === 'monthrange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 14,
          disabled: item?.disabled,
          type: item?.type,
          placeholder: '请选择' + item?.label,
          "value-format": item?.valueFormat || 'YYYY-MM',
          format: "YYYY-MM",
          style: {
            "width": "100%"
          },
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : $setup.dateClearHandle($setup.form[item?.prop], $setup.form)
        }, null, 8, ["disabled", "type", "placeholder", "value-format", "shortcuts", "disabled-date", "picker-options", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'date' || item?.type === 'daterange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 15,
          disabled: item?.disabled,
          type: item?.type,
          placeholder: '请选择' + item?.label,
          "value-format": item?.valueFormat || 'YYYY-MM-DD',
          format: "YYYY-MM-DD",
          style: {
            "width": "100%"
          },
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : $setup.dateClearHandle($setup.form[item?.prop], $setup.form)
        }, null, 8, ["disabled", "type", "placeholder", "value-format", "shortcuts", "disabled-date", "picker-options", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'time' ? (_openBlock(), _createBlock(_component_el_time_select, {
          key: 16,
          style: {
            "width": "100%"
          },
          format: item?.format || 'HH:mm:ss',
          "value-format": item?.valueFormat || 'HH:mm:ss',
          "picker-options": item?.pickerOptions,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null
        }, null, 8, ["format", "value-format", "picker-options", "disabled", "placeholder", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'datetime' || item?.type === 'datetimerange' ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 17,
          style: {
            "width": "100%"
          },
          type: item?.type,
          format: item?.format || 'YYYY-MM-DD HH:mm:ss',
          "value-format": item?.valueFormat || 'YYYY-MM-DD HH:mm:ss',
          shortcuts: item?.pickerOptions?.shortcuts,
          "disabled-date": item?.pickerOptions?.disabledDate,
          "picker-options": item?.pickerOptions,
          placeholder: '请选择' + item?.label,
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          class: _normalizeClass(item?.className ? item.className : ''),
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null
        }, null, 8, ["type", "format", "value-format", "shortcuts", "disabled-date", "picker-options", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "class", "onChange"])) : _createCommentVNode("", true), item?.type === 'switch' ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 18,
          disabled: item?.disabled,
          onChange: $event => item?.change ? item.change($setup.form[item?.prop]) : null,
          "active-value": item?.switch?.active || item?.switch?.active === 0 ? item?.switch?.active : '0',
          "inactive-value": item?.switch?.inActive || item?.switch?.inActive === 0 ? item?.switch?.inActive : '1',
          "active-text": item?.switch?.activeText || '',
          "inactive-text": item?.switch?.inActiveText || '',
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event
        }, null, 8, ["disabled", "onChange", "active-value", "inactive-value", "active-text", "inactive-text", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item?.type === 'cascader' ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 19,
          ref_for: true,
          ref: "cascader",
          style: _normalizeStyle({
            width: item.width
          }),
          onChange: $event => item?.change($setup.form[item?.prop], item?.options, $setup.cascader),
          props: item?.treeProps,
          "show-all-levels": item?.textLevel,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          options: item?.options,
          size: item?.size || $setup.size,
          clearable: ""
        }, null, 8, ["style", "onChange", "props", "show-all-levels", "disabled", "placeholder", "modelValue", "onUpdate:modelValue", "options", "size"])) : _createCommentVNode("", true), item?.type === 'cascaderCheck' ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 20,
          ref_for: true,
          ref: "cascaderCheck",
          style: _normalizeStyle({
            width: item.width
          }),
          placeholder: '请选择' + item?.label,
          options: item?.options,
          props: item?.props,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          filterable: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          clearable: "",
          onChange: $event => item?.change($setup.form[item?.prop], item?.options, $setup.cascader)
        }, null, 8, ["style", "placeholder", "options", "props", "modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), item?.type === 'dialog-select' ? (_openBlock(), _createBlock(_component_dialog_select, {
          key: 21,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled || item.disabledHandle?.(item.prop, $setup.form),
          options: item?.options || {
            localConfig: false
          },
          placeholder: '请选择' + item?.label,
          multiple: item?.multiple || false,
          url: item?.optionsUrl,
          extraParams: item?.extraParams || $setup.form,
          extraParamsProps: item?.extraParamsProps,
          needExtraParams: item?.needExtraParams || false,
          showLabel: item?.showLabel ? item.showLabel : false,
          dialogWidth: item?.dialogWidth ? item.dialogWidth : '960px',
          labelStr: $setup.form[item?.labelStr],
          labelStr2: $setup.form[item?.labelStr2],
          labelStr3: $setup.form[item?.labelStr3],
          style: _normalizeStyle({
            width: item?.width
          }),
          onSelectLabel: (val, val2, val3) => {
            item?.selectLabel ? item.selectLabel(val, val2, val3) : null;
          },
          method: item?.method,
          showSelectInfo: item?.showSelectInfo,
          showSelectInfoTip: item?.showSelectInfoTip
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options", "placeholder", "multiple", "url", "extraParams", "extraParamsProps", "needExtraParams", "showLabel", "dialogWidth", "labelStr", "labelStr2", "labelStr3", "style", "onSelectLabel", "method", "showSelectInfo", "showSelectInfoTip"])) : _createCommentVNode("", true), item?.type === 'dialog-tab-select' ? (_openBlock(), _createBlock(_component_dialog_tab_select, {
          key: 22,
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          disabled: item?.disabled,
          placeholder: '请选择' + item?.label,
          multiple: item?.multiple || false,
          tabsList: item?.tabsList,
          tableHeader: item?.tableHeader,
          noTabsListTip: item?.noTabsListTip,
          labelStr: $setup.form[item?.labelStr],
          style: _normalizeStyle({
            width: item?.width
          }),
          method: item?.method
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder", "multiple", "tabsList", "tableHeader", "noTabsListTip", "labelStr", "style", "method"])) : _createCommentVNode("", true), item?.type === 'basic-upload' ? (_openBlock(), _createBlock(_component_el_upload, {
          key: 23,
          class: "upload-demo",
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          action: item?.action,
          "auto-upload": item?.autoUpload,
          onChange: item?.onChange,
          "on-preview": item?.handlePreview,
          "on-remove": item?.handleRemove,
          "before-upload": item?.beforeUpload,
          "before-remove": item?.beforeRemove,
          multiple: item?.multiple,
          limit: item?.limit || 1,
          "on-exceed": item?.handleExceed,
          "file-list": item?.fileList,
          drag: item?.drag,
          "on-success": item?.onSuccess
        }, {
          tip: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(item?.tip), 1)]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_Upload)]),
            _: 1
          }), item?.drag ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createTextVNode(" Drop file here or "), _hoisted_15])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.upLoadText || "上传"), 1)]),
            _: 2
          }, 1024))]),
          _: 2
        }, 1032, ["disabled", "action", "auto-upload", "onChange", "on-preview", "on-remove", "before-upload", "before-remove", "multiple", "limit", "on-exceed", "file-list", "drag", "on-success"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "prop"])], 2)), [[_vShow, !item?.hideHandle?.(item?.prop, $setup.form) && item?.type != 'textarea']]);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remark, item => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(item?.span ? item?.minWidth ? 'search_item_' + item?.span + ' ' + 'search_item_min_' + item?.minWidth : 'search_item_' + item?.span : item?.minWidth ? 'search_item_12 ' + 'search_item_min_' + item?.minWidth : 'search_item_12'),
        key: item?.prop
      }, [_createVNode(_component_el_form_item, {
        label: $setup.showLabel ? item?.label : '',
        prop: item?.prop
      }, {
        default: _withCtx(() => [item?.type === 'textarea' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          clearable: "",
          modelValue: $setup.form[item?.prop],
          "onUpdate:modelValue": $event => $setup.form[item?.prop] = $event,
          modelModifiers: {
            trim: true
          },
          type: "textarea",
          disabled: item.disabled || item.disabledHandle?.(item.prop, $setup.form),
          placeholder: item?.placeholder,
          maxlength: "200",
          "show-word-limit": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "prop"])], 2)), [[_vShow, !item?.hideHandle?.(item?.prop, $setup.form)]]);
    }), 128))])), $setup.isHandle ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formHandle, item => {
      return _openBlock(), _createBlock(_component_el_form_item, {
        key: item?.label
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: item?.type,
          class: _normalizeClass(item?.class),
          disabled: item?.disabled,
          icon: $setup.icon(item?.label),
          size: item?.size || $setup.size,
          onClick: $event => item?.handle()
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.label), 1)]),
          _: 2
        }, 1032, ["type", "class", "disabled", "icon", "size", "onClick"])]),
        _: 2
      }, 1024);
    }), 128)), $props.hasSearchToggle ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["toggle_handle", {
        'noToggle_handle': $setup.toggle
      }])
    }, [$setup.toggle ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      onClick: _cache[0] || (_cache[0] = $event => $setup.toggle = !$setup.toggle)
    }, {
      default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
      _: 1
    })) : _createCommentVNode("", true), !$setup.toggle ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      onClick: _cache[1] || (_cache[1] = $event => $setup.toggle = !$setup.toggle)
    }, {
      default: _withCtx(() => [_createVNode(_component_ArrowUp)]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("span", {
      onClick: _cache[2] || (_cache[2] = $event => $setup.toggle = !$setup.toggle)
    }, _toDisplayString(!$setup.toggle ? '收起' : '展开'), 1)], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["size", "label-width", "model", "rules", "disabled", "label-position", "class"]);
}